import React from 'react';
import { validateName, getNameValidationMessage } from '../utils/validation';

const MainScreen = ({
    contact,
    randomVibes,
    selectedVibe,
    customMessage,
    isSending,
    refreshCount,
    maxRefreshes,
    onVibeSelect,
    onMessageChange,
    onRefreshOptions,
    onSend
}) => {
    const isVibeSelected = selectedVibe !== null;
    const canRefresh = refreshCount <= maxRefreshes;
    const isNameValid = validateName(customMessage);
    const canSend = isVibeSelected && isNameValid;
    const validationMessage = getNameValidationMessage(customMessage, selectedVibe);

    const handleVibeClick = (vibe) => {
        onVibeSelect(vibe);
    };

    const handleMessageChange = (e) => {
        onMessageChange(e.target.value);
    };

    const handleSendClick = () => {
        if (!isVibeSelected) {
            return;
        }
        
        if (!isNameValid) {
            alert('Please add a name');
            return;
        }
        
        if (!isSending) {
            onSend();
        }
    };

    const handleRefreshClick = () => {
        if (canRefresh) {
            onRefreshOptions();
        }
    };

    return (
        <div className="main-screen">
            {/* Profile Section */}
            <div className="profile-section">
                <div className="profile-avatar">
                    <img 
                        src={contact.profilePhoto} 
                        alt="Profile" 
                        className="avatar-img"
                    />
                </div>
                <div className="profile-name">{contact.name}</div>
                <div className="instruction-container">
                    <span className="instruction-text">Pick their Vibe</span>
                    <button 
                        className={`shuffle-btn ${!canRefresh ? 'disabled' : ''}`}
                        onClick={handleRefreshClick}
                        disabled={!canRefresh}
                    >
                        <img src="assets/images/icons/Shuffle.png" alt="Shuffle" />
                    </button>
                </div>
            </div>

            {/* Vibes Grid */}
            <div className="vibes-grid">
                {randomVibes.map((vibe) => (
                    <div
                        key={vibe.id}
                        className={`vibe-item ${selectedVibe && selectedVibe.id !== vibe.id ? 'dimmed' : ''}`}
                    >
                        <div className="vibe-emoji">{vibe.emoji}</div>
                        <button 
                            className={`vibe-button ${selectedVibe && selectedVibe.id === vibe.id ? 'selected' : ''}`}
                            onClick={() => handleVibeClick(vibe)}
                        >
                            {vibe.name}
                        </button>
                    </div>
                ))}
            </div>

            {/* XOXO Section */}
            <div className="xoxo-section">
                <div className="xoxo-title">XOXO</div>
                <div className="message-input-container">
                    <input
                        type="text"
                        className="message-input"
                        placeholder="Type your name"
                        maxLength="50"
                        value={customMessage}
                        onChange={handleMessageChange}
                    />
                </div>
                {validationMessage && (
                    <div className="validation-message" style={{ 
                        color: '#ff6b6b', 
                        fontSize: '12px', 
                        marginTop: '5px', 
                        textAlign: 'center' 
                    }}>
                        {validationMessage}
                    </div>
                )}
            </div>

            {/* Send Button */}
            <div className="send-button-container">
                <button
                    className={`send-btn ${!canSend ? 'disabled' : ''}`}
                    onClick={handleSendClick}
                    disabled={!canSend || isSending}
                >
                    <span>{isSending ? 'Sending...' : 'Send'}</span>
                </button>
            </div>
        </div>
    );
};

export default MainScreen;